
<template>
  <div class="cores">
    <template>
      <v-card>
      <v-card-title>
      Account Product Config
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="fi"
        :loading="loading"
        :items-per-page="10"
        :search="search"
        class="elevation-2"

      >

        <template slot="items" slot-scope="props">
          <td>{{ props.item }}</td>
          <td>
            <v-btn color="info" dark @click="editItem(props)">
                <font-awesome-icon icon="edit" class="pr-1"/> Edit
            </v-btn>
          </td>
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
        </template>
      </v-data-table>
      </v-card>
    </template>
	<v-dialog v-model="dialog" persistent max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn @click="newItem()" color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">New Item</span>
                </v-card-title>
                <v-card-text>
					<v-container>
					<v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.fiId" label="FI ID"
                    :disabled="newItemCheck==false" type="number" :rules="['Required']">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.productId" label="Product ID"
                    :disabled="newItemCheck==false" type="number" :rules="['Required']">

                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.config.coreName" label="Core Name"></v-text-field>
                  </v-col>
                  <div v-if="editedItem.config.moverType === 'sftp'">
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.config.moverParameters" label="Mover Parameters">

                      </v-text-field>
                    </v-col>
                  </div>
					        <v-col cols="12" sm="6" md="4">
                    <v-switch v-model="editedItem.config.needsEmptyFiles" label="Needs Empty Files">

                    </v-switch>
                  </v-col>
                </v-row>
					</v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

@Component
export default class AccountProductTable extends Vue {
  cores= []

/*eslint-disable */
  data() {
    return {
      search : '',
      dialog: false,
      selected: [],
      newItemCheck: false,
    }
  }
  /* eslint-enable */


  emptyItem = {
    productId: null,
    fiId: null,
    config: {
      // CHANGE THESE FIELDS WHEN ACCOUNT INTEGRATIONS IS NEEDED
      coreName: '',
      moverParameters: '',
      moverType: '',
      needsEmptyFiles: false,
    },
  };

  editedItem = this.emptyItem

  loading = false;

  headers = [
    {
      text: 'Product ID',
      value: 'item',
      sortable: true,
      align: 'left',
    },
    { text: 'Actions', value: 'action', sortable: false },
  ];


  newItem() {
    this.newItemCheck = true;
    this.editedItem = this.emptyItem;
  }


  editItem(item) {
    this.newItemCheck = false;
    this.$http
      .get(
        `https://pi-config.k8s.dev.ksops.net/accountintegrations/ficonfig/${item.item}/${item.item}`,
      )
      .then((data) => {
        this.editedItem = data.data;
      })
      .finally(() => {
        this.loading = false;
      });


    this.dialog = true;
    this.loading = true;
  }


  close() {
    this.dialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.emptyItem);
    }, 300);
  }

  validateInput(item) {
    if (item.fiId === null || item.productId === null) {
      alert('Check your fiId or product input');
      return false;
    }
    if (this.fi.includes(Number(item.fiId)) && this.newItemCheck === true) {
      alert('This fiId has already been created before - please edit the record instead of re-creating the record');
      return false;
    }
    return true;
  }

  save() {
    this.dialog = false;
    if (!this.validateInput(this.editedItem)) {
      return;
    }


    const payload = { productId: this.editedItem.productId, fiId: this.editedItem.fiId };
    const keys = Object.keys(this.editedItem.config);
    const values = Object.values(this.editedItem.config);
    for (let i = 0; i < keys.length; i += 1) {
      payload[keys[i]] = values[i];
    }
    console.log('Submitting info');
    console.log(payload);

    this.$http
      .post(
        'https://pi-config.k8s.dev.ksops.net/accountintegrations/ficonfig/', payload,
      )
      .then((data) => {
        console.log(data);
      })
      .finally(() => {
        this.loading = false;
      });
    this.close();
  }

  mounted() {
    this.loading = true;
    // UNCOMMENT ONCE WE NEED ACCOUNT PRODUCT
    /*
    this.$http
      .get(
        'https://pi-config.k8s.dev.ksops.net/accountintegrations/ficonfig/retrieve-all/productId',
      )
      .then((data) => {
        this.fi = data.data;
        console.log(data);
      })
      .finally(() => {
        this.loading = false;
      });
      */
  }
}
</script>
